module.exports = __webpack_public_path__ + "img/call.a8dde10a.png";